




























































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import MultilevelCategoriesFetcher from "@/components/app/admin/catalogue/products/multilevelCategories/multilevelCategoriesFetchMixin";

// Enums
import { ProductTypes } from "@/data/enums/products";
import { DataModules } from "@/store/modules/data";
import { SortableItems } from "@/data/enums/sortableItems";

// Types
import {
  IProduct,
  IProductCategory,
  ISortableMultilevelCategory
} from "@/models/products";

@Component
export default class MultilevelCategoriesWithProducts extends Mixins(
  RequestPromises,
  MultilevelCategoriesFetcher
) {
  @Prop({ default: 10 })
  public limit!: number;

  @Prop({ default: "main" })
  public scope!: number;

  @Prop({ default: false })
  public showTreeView!: boolean;

  public isLoading = true;
  public isReloading = false;
  public requestError = false;

  public categoriesModule: string = DataModules.CATALOGUE_CATEGORIES;
  public sortableData: ISortableMultilevelCategory[] = [];

  public catalogueId = "CT1";

  public created() {
    this.loadData();
  }

  public async loadData() {
    try {
      await this.getRootCategories(true);
      this.sortableData = this.mapCategories(this.rootCategories, [], 0);
      await this.fillOpennedCategories();
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }

    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public async fillOpennedCategories() {
    const queryCategories = this.$_.filter(
      this.$_.get(this.$_.clone(this.$route.query), `[${this.catalogueId}]`, "")
        .toString()
        .split("|"),
      category => {
        return category !== undefined && category !== "";
      }
    );

    this.sortableData = this.fillCategoriesWithProducts(
      this.sortableData,
      await this.loadAllCategoriesProducts(queryCategories)
    );
  }

  public fillCategoriesWithProducts(categories, loadedCategories) {
    return this.$_.map(categories, category => {
      const loadedCategory = this.$_.find(loadedCategories, [
        "id",
        category.id
      ]);

      if (loadedCategory) {
        category = this.$_.merge(category, {
          isOpened: true,
          isFullyLoaded: loadedCategory.total === loadedCategory.items.length,
          offset: loadedCategory.items.length,
          leftToLoad: loadedCategory.total - loadedCategory.items.length
        });

        category.items = this.$_.concat(loadedCategory.items, category.items);
      }

      category.items = this.$_.get(category, "items", []).length
        ? this.fillCategoriesWithProducts(category.items, loadedCategories)
        : [];

      return category;
    });
  }

  public async loadAllCategoriesProducts(queryCategories) {
    const loadedCategories: any = [];

    for (let i = 0; i < queryCategories.length; i++) {
      const queryParams = queryCategories[i].split(":");
      const results = await this.loadItems(queryParams[0], 0, queryParams[1]);

      loadedCategories.push({
        id: queryParams[0],
        total: this.$_.get(results, "total"),
        items: this.$_.get(results, "items")
      });
    }

    return loadedCategories;
  }

  public openCloseCategory(categoryId, isOpen, offset) {
    const query = this.$_.clone(this.$route.query);

    let queryCategories = this.$_.filter(
      this.$_.get(query, `[${this.catalogueId}]`, "")
        .toString()
        .split("|"),
      category => {
        return category !== undefined && category !== "";
      }
    );

    if (isOpen) {
      if (
        this.$_.find(
          queryCategories,
          category => category.indexOf(`${categoryId}:`) === 0
        )
      ) {
        queryCategories = this.$_.map(queryCategories, category => {
          if (category.indexOf(`${categoryId}:`) === 0) {
            category = `${categoryId}:${offset}`;
          }
          return category;
        });
      } else {
        queryCategories.push(`${categoryId}:${offset}`);
      }
    } else {
      queryCategories = this.$_.filter(
        queryCategories,
        category => category.indexOf(`${categoryId}:`) !== 0
      );
    }

    if (queryCategories.length) {
      query[this.catalogueId] = queryCategories.join("|");
    } else {
      delete query[this.catalogueId];
    }

    this.$router.push({ query });
  }

  public get isOption() {
    return this.productTypes.includes(ProductTypes.PRODUCT_OPTION);
  }

  public get isAttribute() {
    return this.productTypes.includes(ProductTypes.PRODUCT_ATTRIBUTE);
  }

  public get i18n() {
    return {
      emptyResultsTitle: this.isOption
        ? this.$t(`_.no_product_options_attached`)
        : this.isAttribute
        ? this.$t(`_.no_product_attributes_attached`)
        : this.$t(`_.no_products_attached`),
      emptyResultsMsg: this.isOption
        ? this.$t(`_sentence.no_product_options_attached_msg`)
        : this.isAttribute
        ? this.$t(`_sentence.no_product_attributes_attached_msg`)
        : this.$t(`_sentence.no_products_attached_msg`),
      label: this.isOption
        ? this.$t(`_.manage_selected_product_options`)
        : this.isAttribute
        ? this.$t(`_.manage_selected_product_attributes`)
        : this.$t(`_.manage_selected_products`),
      hidden: this.$t("_.hidden"),
      hiddenDescription: this.$t("_sentence.hidden_desc"),
      inactive: this.$t("_.inactive"),
      inactiveDescription: this.$t("_sentence.inactive_desc"),
      bundle: this.$t("_.bundle"),
      bundleDescription: this.$t("_sentence.product_bundle_desc")
    };
  }

  public mapCategories(
    categories: IProductCategory[],
    parentCategories,
    level
  ) {
    return this.$_.map(
      this.$_.orderBy(categories, ["order", "asc"]),
      (category: IProductCategory, index: number) => {
        return this.$_.merge(this.$_.pick(category, ["id", "name"]), {
          isOpened: false,
          isLoading: false,
          isInitialising: false,
          isFullyLoaded: false,
          offset: 0,
          type: SortableItems.CATEGORY,
          itemsTotal:
            this.$_.get(category, "products_count", 0) +
            this.$_.get(category, "sub_products_count", 0),
          itemsTotalMsg: this.itemsCounter(),
          level: level + 1,
          index,
          parentCategories,
          items: this.$_.concat(
            [],
            this.mapCategories(
              category.subcategories || [],
              this.$_.concat(parentCategories, [
                this.$_.merge(this.$_.pick(category, ["id", "name"]), {
                  level: level + 1,
                  index
                })
              ]),
              level + 1
            )
          )
        });
      }
    );
  }

  public itemsCounter() {
    return this.isOption
      ? "_plurals.product_options"
      : this.isAttribute
      ? "_plurals.product_attributes"
      : "_plurals.products";
  }

  public async reorder(movedElement: any) {
    const result =
      movedElement.itemMoved.type === SortableItems.ITEM
        ? await this.updateProduct(movedElement)
        : await this.updateCategory(movedElement);

    if (movedElement.itemMoved.type === SortableItems.CATEGORY) {
      await this.getRootCategories(true);
    }

    return result;
  }

  public async createSubcategory(parentCategoryId: IProductCategory["id"]) {
    const result = await this.$store.dispatch(
      `data/${DataModules.CATALOGUE_CATEGORIES}/openAddEditCategoryModal`,
      {
        productTypes: this.productTypes,
        parentCategoryId: parentCategoryId
      }
    );
    return result;
  }

  public createItem(parentCategoryId: IProductCategory["id"]) {
    return this.$store.dispatch(
      `data/${DataModules.CATALOGUE}/openAddProductModal`,
      {
        props: {
          productTypes: this.productTypes,
          categoryId: parentCategoryId
        }
      }
    );
  }

  public async view(element) {
    element.type === SortableItems.ITEM
      ? this.viewProduct(element.itemId)
      : this.viewCategory(element.id);
    return { cancelled: true };
  }

  public duplicateProduct(productId: IProduct["id"]) {
    return this.$store.dispatch(`data/${DataModules.CATALOGUE}/duplicate`, {
      id: productId
    });
  }

  public async startProductDuplication(params) {
    try {
      await this.duplicateProduct(params.itemId);
      this.$store.dispatch("toast/show", {
        message: this.$t("_.object_successfully_duplicated", {
          object: this.productWithType
        })
      });
      this.$emit("refreshTreeView");
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  public async confirmDelete(
    id: IProduct["id"] | IProductCategory["id"],
    type: string
  ) {
    return new Promise(resolve => {
      this.$store.dispatch(`data/${DataModules.CATALOGUE}/confirmDelete`, {
        props: {
          message: this.$t("_sentence.delete_confirmation", {
            object: this.getDeleteMessage(type)
              .toString()
              .toLowerCase()
          })
        },
        onConfirm: async () => {
          try {
            if (type === SortableItems.ITEM) {
              await this.deleteProduct(id);
            } else {
              await this.deleteCategory(id);
              await this.getRootCategories(true);
            }

            this.$store.dispatch("toast/show", {
              message: this.$t("_.object_successfully_removed", {
                object: this.getDeleteMessage(type)
              })
            });
            resolve({ deleteConfirmed: true });
          } catch (error) {
            this.$store.dispatch("api/handleError", error);
            resolve({ deleteConfirmed: false });
          }
        }
      });
    });
  }

  public updateProduct(product) {
    return this.$store.dispatch(`data/${DataModules.CATALOGUE}/update`, {
      id: product.itemMoved.itemId,
      data: this.$_.merge(
        product.newCategory !== product.oldCategory
          ? {
              category_id: product.newCategory
            }
          : {},
        { order: product.itemOrder }
      )
    });
  }

  public updateCategory(category) {
    return this.$store.dispatch(
      `data/${DataModules.CATALOGUE_CATEGORIES}/update`,
      {
        id: category.itemMoved.id,
        productTypes: this.productTypes,
        data: this.$_.merge(
          category.newCategory !== category.oldCategory
            ? {
                parent_id:
                  category.newCategory === "" ? null : category.newCategory
              }
            : {},
          { order: category.categoryOrder }
        )
      }
    );
  }

  public getDeleteMessage(type: string) {
    if (type === SortableItems.ITEM) {
      return this.$t(
        this.isOption
          ? "_.product_option"
          : this.isAttribute
          ? "_.product_attribute"
          : "_.product"
      );
    }

    return this.$t(
      this.isOption
        ? "_.product_options_category"
        : this.isAttribute
        ? "_.product_attributes_category"
        : "_.products_category"
    );
  }

  public get productWithType() {
    return this.isOption
      ? this.$t("_.product_option")
      : this.isAttribute
      ? this.$t("_.product_attribute")
      : this.$t("_.product");
  }

  public async loadItems(
    categoryId: IProductCategory["id"],
    offset,
    limit = this.limit
  ) {
    const apiProps = {
      "filter[product_type]": this.productTypes.join(","),
      order: "order",
      limit,
      offset,
      brand_id: this.brandId
    };

    apiProps[
      `filter[products${
        this.isOption ? "_options" : this.isAttribute ? "_attributes" : ""
      }_category_id]`
    ] = categoryId;

    const results = await this.$store.dispatch(
      `data/${DataModules.CATALOGUE}/list`,
      {
        productTypes: this.productTypes,
        params: apiProps,
        vm: this,
        storeData: false,
        returnData: false
      }
    );

    return {
      total: results.total,
      items: this.mapProducts(results.data)
    };
  }

  public mapProducts(products: any[]) {
    return this.$_.map(
      this.$_.orderBy(products, ["order", "asc"]),
      (product: IProduct) => {
        return this.$_.merge(this.$_.pick(product, ["name", "order"]), {
          id: `${SortableItems.ITEM}_${this.$_.get(product, "id")}`,
          itemId: this.$_.get(product, "id"),
          type: SortableItems.ITEM,
          labels: this.$_.concat(
            this.$_.get(product, "product_type") === ProductTypes.PRODUCT_BUNDLE
              ? [
                  {
                    title: this.i18n.bundle,
                    type: "is-info",
                    description: this.i18n.bundleDescription
                  }
                ]
              : [],
            this.$_.get(product, "available_for_sales")
              ? []
              : [
                  {
                    title: this.i18n.inactive,
                    type: "is-dark",
                    description: this.i18n.inactiveDescription
                  }
                ],
            this.$_.get(product, "clients_can_order")
              ? []
              : [
                  {
                    title: this.i18n.hidden,
                    type: "is-grey",
                    description: this.i18n.hiddenDescription
                  }
                ]
          )
        });
      }
    );
  }

  public viewProduct(productId: IProduct["id"]): void {
    this.$router.push({
      name: this.productRouteName,
      params: { productId }
    });
  }

  public viewCategory(categoryId: IProductCategory["id"]): void {
    this.$router.push({
      name: this.categoryRouteName,
      params: { categoryId }
    });
  }

  public get productRouteName() {
    if (this.isOption) return "adminCatalogueOption";
    if (this.isAttribute) return "adminCatalogueAttribute";

    return "adminCatalogueProduct";
  }

  public get categoryRouteName() {
    if (this.isOption) return "adminCatalogueOptionCategory";
    if (this.isAttribute) return "adminCatalogueAttributeCategory";

    return "adminCatalogueCategory";
  }

  public deleteProduct(productId: IProduct["id"]) {
    return this.$store.dispatch(`data/${DataModules.CATALOGUE}/remove`, {
      id: productId,
      productTypes: this.productTypes
    });
  }

  public deleteCategory(categoryId: IProductCategory["id"]) {
    return this.$store.dispatch(
      `data/${DataModules.CATALOGUE_CATEGORIES}/remove`,
      {
        id: categoryId,
        productTypes: this.productTypes
      }
    );
  }

  public get getGuardFuncionalities() {
    return this.isOption
      ? ["staff_list_products", "list_product_options_categories"]
      : this.isAttribute
      ? ["staff_list_products", "list_product_attributes_categories"]
      : ["staff_list_products", "list_product_categories"];
  }
}
